import React from 'react';
import { translate } from '../Services/translation';
const ComplimentaryProducts = ({ complimentary }) => {
    return (
        complimentary && complimentary.length > 0 &&
        <div>
            {translate('checkout.complimentaryproduct')}
            {/* *TODO: modify styles in MidaqTheme/productHorizontalList.scss  */}
            <div className="row product__vertical-list">
                <ul className="product__vertical-list-container">
                    {complimentary &&
                        complimentary.map((product, index) => (
                            <li className="product__vertical-list-item" key={index}>
                                <div className="product__vertical-list-price-container" >
                                    <div className="product__vertical-list-img-container">
                                        <img src={product.imageUrl} />
                                    </div>
                                    <div className="product__vertical-list-info-container">
                                        <a href={product.url}>
                                            <span className="product__vertical-list-name">{product.name}</span>
                                            <span className="product__vertical-list-price">
                                                {
                                                    (product.price != undefined && product.price.campaignPrice != undefined || '') &&
                                                    <div>
                                                        <span className="product__campaign-price">
                                                            {product.price.formattedCampaignPrice}
                                                        </span> &nbsp;
                                                        <span className="product__old-price">
                                                            {product.price.formattedPrice}
                                                        </span>
                                                    </div>
                                                }
                                                {product.price != undefined && product.price.campaignPrice == undefined &&
                                                    <div>
                                                        <span className="product__campaign-price">
                                                            {product.price.formattedPrice}
                                                        </span>
                                                    </div>
                                                }
                                            </span>
                                        </a>
                                    </div>
                                </div>
                                <div className="product__vertical-list-button-container">
                                    <button className="button-pill button-pill--primary" onClick={() => {
                                        location.href = product.url
                                    }}    >Visa</button>
                                </div>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    );
};
export default ComplimentaryProducts;
